import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageContainer from "../../common_components/PageContainer";
import ClientHeader from "./Component/ClientListHeader";
import ClientListControls from "./Component/ClientListControls";
import ClientMap from "./Component/ClientMap";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientList, fetchDesignationWiseUsers } from "../../redux/clientDataSlice";
import CommonLoader from "../../common_components/CommonLoader";
import Pagination from "../../common_components/Pagination";
import { Box } from "@mui/material";
import { selectUser } from "../../redux/authSlice";
const CLIENT_PAGINATION = {
    DEFAULT_PAGE: 1,
    LIMIT: 20
};
const ClientListMain = () => {
    const dispatch = useDispatch();
    const hasFetchedDesignationUsers = useRef(false);
    const user = useSelector(selectUser);
    /* ================= STATE ================= */
    const [status, setStatus] = useState("active");
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [type, setType] = useState([]);
    const [selectedAM, setSelectedAM] = useState("");
    const [selectedOperator, setSelectedOperator] = useState("");
    const [network, setNetwork] = useState([]);
    // ✅ page controlled from single config
    const [page, setPage] = useState(CLIENT_PAGINATION.DEFAULT_PAGE);
    const { totalEntries, totalPages, page: currentPage } = useSelector((state) => state.clientData.pagination);
    const loading = useSelector((state) => state.clientData.clientListLoading);
    /* ================= FETCH DESIGNATION USERS ================= */
    useEffect(() => {
        if (hasFetchedDesignationUsers.current)
            return;
        hasFetchedDesignationUsers.current = true;
        dispatch(fetchDesignationWiseUsers());
    }, [dispatch]);
    /* ================= DEBOUNCE SEARCH ================= */
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchText(searchText);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchText]);
    /* ================= PARAM BUILDER (SINGLE SOURCE) ================= */
    const buildClientParams = useCallback(() => {
        const params = new URLSearchParams();
        params.append("page", String(page));
        params.append("limit", String(CLIENT_PAGINATION.LIMIT));
        params.append("status", status);
        if (debouncedSearchText)
            params.append("searchText", debouncedSearchText);
        if (selectedAM)
            params.append("am_id", selectedAM);
        if (selectedOperator)
            params.append("operator_id", selectedOperator);
        type.forEach(t => params.append("type", t));
        network.forEach(n => params.append("network", n));
        return params;
    }, [
        page,
        status,
        debouncedSearchText,
        selectedAM,
        selectedOperator,
        type,
        network
    ]);
    const activeFetchRef = useRef(null);
    /* ================= CLIENT LIST FETCH ================= */
    useEffect(() => {
        if (activeFetchRef.current) {
            activeFetchRef.current.abort();
        }
        const promise = dispatch(fetchClientList({ params: buildClientParams() }));
        activeFetchRef.current = promise;
        return () => {
            promise.abort();
        };
    }, [dispatch, buildClientParams]);
    /* ================= REFETCH ================= */
    const refetchClientList = useCallback(() => {
        if (activeFetchRef.current) {
            activeFetchRef.current.abort();
        }
        const promise = dispatch(fetchClientList({ params: buildClientParams() }));
        activeFetchRef.current = promise;
    }, [dispatch, buildClientParams]);
    /* ================= RESET PAGE ON FILTER CHANGE ================= */
    useEffect(() => {
        setPage(CLIENT_PAGINATION.DEFAULT_PAGE);
    }, [status, debouncedSearchText, selectedAM, selectedOperator, type, network]);
    /* ================= PAGE CHANGE ================= */
    const handlePageChange = useCallback((newPage) => setPage(newPage), []);
    /* ================= UI ================= */
    return (_jsx(PageContainer, { children: _jsxs("div", { className: "client-list-container", children: [_jsxs("div", { className: "client-list-header-fixed", children: [_jsx(ClientHeader, { selectedAM: selectedAM, setSelectedAM: setSelectedAM, selectedOperator: selectedOperator, setSelectedOperator: setSelectedOperator, type: type, setType: setType, network: network, setNetwork: setNetwork, setPage: setPage }), _jsx(ClientListControls, { status: status, setStatus: setStatus, searchText: searchText, setSearchText: setSearchText, setPage: setPage, refetchClientList: refetchClientList })] }), _jsx("div", { className: "client-list-scrollable", children: loading ? (_jsx(Box, { className: "reusable-table-loading", sx: { p: 4, textAlign: "center" }, children: _jsx(CommonLoader, { className: 'table-loader' }) })) : (_jsx(ClientMap, { setPage: setPage, refetchClientList: refetchClientList, status: status })) }), totalEntries > 0 && (_jsx("div", { className: "client-pagination-fixed", children: _jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: handlePageChange, maxVisiblePages: 5, totalEntries: totalEntries, itemsPerPage: CLIENT_PAGINATION.LIMIT, showEntriesMessage: true }) }))] }) }));
};
export default ClientListMain;
